import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Zet admin custom claim voor een user
 * @param {string} email - Email van de user die admin moet worden
 * @returns {Promise<{success: boolean, message?: string, error?: string}>}
 */
export const setAdminClaim = async (email) => {
  if (!email || !email.includes('@')) {
    return { 
      success: false, 
      error: 'Ongeldig email adres' 
    };
  }

  try {
    const functions = getFunctions();
    const setAdminClaimFn = httpsCallable(functions, 'setAdminClaim');
    
    const result = await setAdminClaimFn({ email });
    
    return { 
      success: true, 
      message: result.data.message 
    };
    
  } catch (error) {
    console.error('Error setting admin claim:', error);
    
    // Parse Firebase error messages
    let errorMessage = error.message;
    if (error.code === 'functions/not-found') {
      errorMessage = 'Cloud function niet gevonden. Is deze deployed?';
    } else if (error.code === 'functions/permission-denied') {
      errorMessage = 'Geen toegang. Alleen super admin kan dit doen.';
    }
    
    return { 
      success: false, 
      error: errorMessage 
    };
  }
};